import { buildMock } from 'utils'

export default buildMock({
  id: 'ABC',
  avatar: 'avatar.jpg',
  email: 'user@email.com',
  first_name: 'fname',
  last_name: 'lname',
  level: 23,
  name: 'Name Last',
  points: 23,
  username: 'username',
})
